<template>
  <NavComponent v-if="pageName !== 'helpPageApp'" />
  <appNavigator :page="pageName" v-if="pageName === 'helpPageApp'" />
  <div class="lg:flex flex-1">
    <helpPage class="flex-1" />
  </div>
  <Footer />
</template>

<script>
import helpPage from "@/pages/helpPage.vue";
import NavComponent from "@/components/new/Nav.vue";
import AppNavigator from "@/components/appNavigator.vue";
import Footer from "@/components/new/Footer.vue";

export default {
  name: "helpView",
  components: {
    AppNavigator,
    NavComponent,
    Footer,
    helpPage,
  },
  data() {
    return {
      pageName: this.$route.name,
    };
  },
  mounted() {},
};
</script>

<style scoped>
.main {
  min-height: calc(100vh - var(--nav-height, 80px));
  margin-top: var(--nav-height, 80px);
}
</style>
